var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1694",
    width: 861.33331,
    height: 255.2092,
    viewBox: "0 0 861.33331 255.2092",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1698"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1712"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,2207.03 H 6460 V 292.961 H 0 Z",
    id: "path1710"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1734"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,2207.04 H 6460 V 292.961 H 0 Z",
    id: "path1732"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1702",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,294.27066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1704",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1708",
    clipPath: "url(#clipPath1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6220.74,292.969 H 239.262 C 107.668,292.969 0,400.629 0,532.23 v 1435.55 c 0,131.6 107.668,239.26 239.262,239.26 H 6220.74 c 131.59,0 239.26,-107.66 239.26,-239.26 V 532.23 c 0,-131.601 -107.67,-239.261 -239.26,-239.261",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6220.74,2207.03 H 239.262 C 107.668,2207.03 0,2099.36 0,1967.77 V 532.219 C 0,400.621 107.668,292.961 239.262,292.961 H 6220.74 c 131.59,0 239.26,107.66 239.26,239.258 V 1967.77 c 0,131.59 -107.67,239.26 -239.26,239.26 m 0,-38.28 c 110.83,0 200.98,-90.15 200.98,-200.98 V 532.219 c 0,-110.828 -90.15,-200.981 -200.98,-200.981 H 239.262 c -110.828,0 -200.9768,90.153 -200.9768,200.981 V 1967.77 c 0,110.83 90.1488,200.98 200.9768,200.98 H 6220.74",
    style: {
      fill: "#a2a2a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5117.09,771.48 h 89.29 v 598.19 h -89.29 z m 804.24,382.72 -102.35,-259.36 h -3.07 L 5709.68,1154.2 H 5613.5 L 5772.8,791.719 5681.98,590.07 h 93.12 l 245.53,564.13 z M 5414.97,839.43 c -29.29,0 -70.06,14.64 -70.06,50.808 0,46.184 50.77,63.844 94.65,63.844 39.24,0 57.71,-8.473 81.59,-20 -6.94,-55.422 -54.65,-94.652 -106.18,-94.652 m 10.76,327.83 c -64.65,0 -131.64,-28.47 -159.34,-91.54 l 79.28,-33.12 c 16.94,33.12 48.48,43.89 81.59,43.89 46.18,0 93.12,-27.71 93.89,-76.95 v -6.17 c -16.17,9.23 -50.82,23.06 -93.12,23.06 -85.42,0 -172.41,-46.942 -172.41,-134.649 0,-80.062 70.05,-131.601 148.53,-131.601 60.05,0 93.12,26.898 113.94,58.48 h 3.06 v -46.18 h 86.18 v 229.36 c 0,106.18 -79.24,165.42 -181.6,165.42 m -551.83,-85.89 h -127 v 205.09 h 127 c 66.76,0 104.65,-55.32 104.65,-102.55 0,-46.37 -37.89,-102.54 -104.65,-102.54 m -2.29,288.3 H 4657.66 V 771.48 h 89.24 v 226.622 h 124.71 c 98.96,0 196.24,71.688 196.24,185.808 0,114.13 -97.28,185.76 -196.24,185.76 M 3704.93,839.328 c -61.68,0 -113.31,51.633 -113.31,122.551 0,71.681 51.63,124.131 113.31,124.131 60.91,0 108.67,-52.45 108.67,-124.131 0,-70.918 -47.76,-122.551 -108.67,-122.551 m 102.5,281.372 h -3.06 c -20.05,23.88 -58.57,45.51 -107.14,45.51 -101.79,0 -195.05,-89.44 -195.05,-204.331 0,-114.078 93.26,-202.75 195.05,-202.75 48.57,0 87.09,21.582 107.14,46.269 h 3.06 v -29.277 c 0,-77.902 -41.59,-119.492 -108.67,-119.492 -54.75,0 -88.67,39.293 -102.55,72.453 l -77.86,-32.402 c 22.35,-53.969 81.74,-120.25 180.41,-120.25 104.84,0 193.51,61.679 193.51,211.992 v 365.438 h -84.84 z M 3953.9,771.48 h 89.44 v 598.24 h -89.44 z m 221.27,197.34 c -2.29,78.67 60.91,118.72 106.37,118.72 35.51,0 65.56,-17.71 75.56,-43.16 z m 277.54,67.85 c -16.99,45.51 -68.62,129.54 -174.23,129.54 -104.84,0 -191.93,-82.5 -191.93,-203.569 0,-114.071 86.33,-203.512 201.94,-203.512 93.31,0 147.23,57.043 169.63,90.199 l -69.38,46.274 c -23.17,-33.922 -54.75,-56.274 -100.25,-56.274 -45.47,0 -77.86,20.82 -98.68,61.633 l 272.14,112.599 z m -2168.07,67.04 v -86.32 h 206.58 c -6.18,-48.57 -22.35,-84.031 -46.99,-108.671 -30.1,-30.098 -77.14,-63.219 -159.59,-63.219 -127.24,0 -226.67,102.5 -226.67,229.74 0,127.19 99.43,229.69 226.67,229.69 68.62,0 118.72,-26.94 155.71,-61.63 l 60.91,60.86 c -51.67,49.34 -120.25,87.14 -216.62,87.14 -174.23,0 -320.7,-141.88 -320.7,-316.06 0,-174.279 146.47,-316.111 320.7,-316.111 94.03,0 164.95,30.871 220.45,88.672 57.04,57.039 74.8,137.187 74.8,201.979 0,20.05 -1.54,38.52 -4.65,53.93 z m 530.1,-264.382 c -61.63,0 -114.84,50.871 -114.84,123.313 0,73.269 53.21,123.369 114.84,123.369 61.68,0 114.89,-50.1 114.89,-123.369 0,-72.442 -53.21,-123.313 -114.89,-123.313 m 0,326.882 c -112.55,0 -204.28,-85.61 -204.28,-203.569 0,-117.141 91.73,-203.512 204.28,-203.512 112.55,0 204.33,86.371 204.33,203.512 0,117.959 -91.78,203.569 -204.33,203.569 m 445.69,-326.882 c -61.67,0 -114.89,50.871 -114.89,123.313 0,73.269 53.22,123.369 114.89,123.369 61.69,0 114.85,-50.1 114.85,-123.369 0,-72.442 -53.16,-123.313 -114.85,-123.313 m 0,326.882 c -112.54,0 -204.28,-85.61 -204.28,-203.569 0,-117.141 91.74,-203.512 204.28,-203.512 112.55,0 204.28,86.371 204.28,203.512 0,117.959 -91.73,203.569 -204.28,203.569",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 991.355,1277.56 481.879,736.828 c 0.047,-0.09 0.047,-0.238 0.098,-0.328 15.644,-58.719 69.238,-101.93 132.882,-101.93 25.457,0 49.336,6.891 69.817,18.95 l 1.625,0.96 573.459,330.891 -268.405,292.189",
    style: {
      fill: "#eb3131",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1506.77,1369.63 -0.48,0.34 -247.59,143.51 -278.927,-248.21 279.927,-279.84 246.25,142.07 c 43.16,23.36 72.5,68.86 72.5,121.31 0,52.16 -28.91,97.42 -71.68,120.82",
    style: {
      fill: "#f6b60b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 481.871,1763.11 c -3.066,-11.29 -4.691,-23.16 -4.691,-35.41 V 772.191 c 0,-12.25 1.625,-24.113 4.738,-35.363 l 526.942,526.902 -526.989,499.38",
    style: {
      fill: "#5778c5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 995.121,1249.95 263.659,263.62 -572.784,332.09 c -20.816,12.49 -45.125,19.67 -71.109,19.67 -63.641,0 -117.332,-43.31 -132.981,-102.07 0,-0.05 -0.047,-0.1 -0.047,-0.15 l 513.262,-513.16",
    style: {
      fill: "#3bad49",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1726"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1730",
    clipPath: "url(#clipPath1734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2093.55,1621.88 c 33.86,0 60.16,9.36 78.89,28.09 18.73,18.74 28.1,44.61 28.1,77.64 0,33.03 -9.37,58.92 -28.1,77.65 -18.73,18.73 -45.03,28.1 -78.89,28.1 h -48.3 v -211.48 z m -94.09,254.78 h 95.34 c 30.81,0 57.66,-6.25 80.55,-18.74 22.9,-12.49 40.52,-30.04 52.87,-52.66 12.36,-22.63 18.53,-48.5 18.53,-77.65 0,-29.14 -6.17,-55.02 -18.53,-77.64 -12.35,-22.62 -29.97,-40.17 -52.87,-52.66 -22.89,-12.49 -49.74,-18.73 -80.55,-18.73 h -95.34 v 298.08",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2306.28,1876.66 h 45.79 v -298.08 h -45.79 v 298.08",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2447.82,1593.56 c -19.7,14.43 -33.44,34.69 -41.21,60.78 l 43.29,17.49 c 4.45,-16.65 12.36,-30.26 23.73,-40.8 11.38,-10.55 25.12,-15.82 41.22,-15.82 14.98,0 27.69,3.88 38.09,11.66 10.41,7.77 15.61,18.45 15.61,32.05 0,12.49 -4.58,22.83 -13.74,31.02 -9.16,8.19 -24.98,16.17 -47.46,23.94 l -18.73,6.66 c -20.26,7.21 -37.12,17.28 -50.58,30.18 -13.46,12.91 -20.19,30.04 -20.19,51.42 0,14.7 3.96,28.31 11.87,40.79 7.91,12.49 19,22.34 33.3,29.56 14.29,7.22 30.46,10.83 48.5,10.83 25.81,0 46.49,-6.32 62.03,-18.94 15.54,-12.64 26.09,-26.86 31.65,-42.68 l -41.23,-17.49 c -2.77,10 -8.6,18.6 -17.48,25.82 -8.88,7.21 -20.4,10.82 -34.56,10.82 -13.59,0 -25.11,-3.61 -34.55,-10.82 -9.43,-7.22 -14.15,-16.38 -14.15,-27.48 0,-10.27 4.23,-18.8 12.7,-25.6 8.45,-6.81 21.57,-13.25 39.33,-19.36 l 19.15,-6.66 c 25.54,-8.89 45.24,-20.4 59.13,-34.55 13.87,-14.16 20.81,-33.04 20.81,-56.62 0,-19.43 -4.93,-35.74 -14.78,-48.92 -9.85,-13.19 -22.48,-22.96 -37.88,-29.35 -15.41,-6.38 -31.16,-9.57 -47.26,-9.57 -24.7,0 -46.9,7.21 -66.61,21.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2777.96,1737.61 c 15.26,0 27.54,4.78 36.84,14.36 9.3,9.58 13.95,20.74 13.95,33.51 0,12.77 -4.65,23.94 -13.95,33.52 -9.3,9.57 -21.58,14.36 -36.84,14.36 h -57.87 v -95.75 z m -103.66,139.05 h 102.41 c 17.76,0 34.06,-3.89 48.92,-11.66 14.84,-7.78 26.64,-18.6 35.39,-32.47 8.74,-13.89 13.11,-29.57 13.11,-47.05 0,-17.48 -4.37,-33.16 -13.11,-47.04 -8.75,-13.88 -20.55,-24.71 -35.39,-32.47 -14.86,-7.77 -31.16,-11.66 -48.92,-11.66 h -56.62 v -115.73 h -45.79 v 298.08",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3122.03,1629.57 c 16.52,9.58 29.56,22.9 39.13,39.97 9.58,17.07 14.37,36.43 14.37,58.07 0,21.66 -4.79,41.01 -14.37,58.08 -9.57,17.07 -22.61,30.39 -39.13,39.97 -16.51,9.57 -34.76,14.36 -54.74,14.36 -19.99,0 -38.24,-4.79 -54.75,-14.36 -16.51,-9.58 -29.55,-22.9 -39.13,-39.97 -9.57,-17.07 -14.37,-36.42 -14.37,-58.08 0,-21.64 4.8,-41 14.37,-58.07 9.58,-17.07 22.62,-30.39 39.13,-39.97 16.51,-9.57 34.76,-14.36 54.75,-14.36 19.98,0 38.23,4.79 54.74,14.36 z m -133.43,-36.84 c -23.59,13.88 -42.12,32.68 -55.57,56.41 -13.47,23.74 -20.2,49.89 -20.2,78.47 0,28.59 6.73,54.75 20.2,78.48 13.45,23.73 31.98,42.53 55.57,56.41 23.59,13.88 49.82,20.82 78.69,20.82 28.86,0 55.01,-6.94 78.47,-20.82 23.45,-13.88 41.91,-32.68 55.37,-56.41 13.46,-23.73 20.19,-49.89 20.19,-78.48 0,-28.58 -6.73,-54.73 -20.19,-78.47 -13.46,-23.73 -31.92,-42.53 -55.37,-56.41 -23.46,-13.88 -49.61,-20.81 -78.47,-20.81 -28.87,0 -55.1,6.93 -78.69,20.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3280.43,1876.66 h 54.12 l 134.88,-218.99 h 2.5 l -2.5,57.46 v 161.53 h 45.38 v -298.08 h -47.46 l -141.54,230.22 h -2.5 l 2.5,-57.46 v -172.76 h -45.38 v 298.08",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3590.17,1876.66 h 45.79 v -298.08 h -45.79 v 298.08",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3827.47,1621.04 c 14.42,0 26.02,4.37 34.76,13.11 8.74,8.75 13.11,19.22 13.11,31.43 0,12.22 -4.51,22.76 -13.52,31.64 -9.03,8.89 -21.03,13.33 -36.02,13.33 h -69.11 v -89.51 z m -7.08,130.3 c 13.88,0 24.98,4.23 33.3,12.71 8.33,8.46 12.49,18.24 12.49,29.34 0,11.1 -4.1,20.75 -12.27,28.94 -8.2,8.18 -18.81,12.28 -31.86,12.28 h -65.36 v -83.27 z m -109.49,125.32 h 111.57 c 15.82,0 30.53,-3.48 44.13,-10.41 13.6,-6.94 24.36,-16.45 32.27,-28.52 7.91,-12.07 11.86,-25.47 11.86,-40.18 0,-14.71 -3.68,-27.54 -11.03,-38.5 -7.36,-10.97 -17.14,-19.36 -29.36,-25.19 v -2.08 c 15.55,-5.28 27.9,-14.02 37.06,-26.23 9.15,-12.21 13.73,-26.64 13.73,-43.3 0,-16.37 -4.23,-30.87 -12.69,-43.5 -8.47,-12.63 -19.85,-22.48 -34.14,-29.56 -14.3,-7.07 -29.91,-10.61 -46.83,-10.61 H 3710.9 v 298.08",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3981.49,1876.66 h 45.8 v -254.78 h 128.22 v -43.3 h -174.02 v 298.08",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4203.81,1876.66 h 180.68 v -43.3 H 4249.6 v -84.09 h 121.56 v -43.3 H 4249.6 v -84.09 h 134.89 v -43.3 h -180.68 v 298.08",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4558.91,1593.56 c -19.71,14.43 -33.45,34.69 -41.21,60.78 l 43.29,17.49 c 4.44,-16.65 12.35,-30.26 23.73,-40.8 11.37,-10.55 25.11,-15.82 41.22,-15.82 14.98,0 27.68,3.88 38.08,11.66 10.41,7.77 15.62,18.45 15.62,32.05 0,12.49 -4.58,22.83 -13.74,31.02 -9.16,8.19 -24.98,16.17 -47.46,23.94 l -18.73,6.66 c -20.27,7.21 -37.12,17.28 -50.59,30.18 -13.46,12.91 -20.18,30.04 -20.18,51.42 0,14.7 3.95,28.31 11.86,40.79 7.91,12.49 19,22.34 33.3,29.56 14.3,7.22 30.46,10.83 48.51,10.83 25.81,0 46.48,-6.32 62.03,-18.94 15.54,-12.64 26.08,-26.86 31.64,-42.68 l -41.22,-17.49 c -2.77,10 -8.6,18.6 -17.48,25.82 -8.89,7.21 -20.4,10.82 -34.56,10.82 -13.6,0 -25.12,-3.61 -34.55,-10.82 -9.44,-7.22 -14.15,-16.38 -14.15,-27.48 0,-10.27 4.23,-18.8 12.69,-25.6 8.46,-6.81 21.57,-13.25 39.34,-19.36 l 19.15,-6.66 c 25.54,-8.89 45.23,-20.4 59.12,-34.55 13.88,-14.16 20.81,-33.04 20.81,-56.62 0,-19.43 -4.92,-35.74 -14.78,-48.92 -9.85,-13.19 -22.48,-22.96 -37.88,-29.35 -15.41,-6.38 -31.16,-9.57 -47.25,-9.57 -24.71,0 -46.91,7.21 -66.61,21.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4832.22,1586.9 c -17.07,9.99 -30.26,24.15 -39.55,42.47 -9.31,18.31 -13.95,39.55 -13.95,63.69 v 183.6 h 45.37 v -186.1 c 0,-22.48 5.83,-40.65 17.49,-54.53 11.65,-13.89 28.17,-20.82 49.54,-20.82 21.65,0 38.3,6.93 49.95,20.82 11.66,13.88 17.49,32.05 17.49,54.53 v 186.1 h 45.39 v -183.6 c 0,-23.87 -4.58,-44.96 -13.74,-63.28 -9.16,-18.31 -22.21,-32.54 -39.14,-42.67 -16.93,-10.13 -36.92,-15.19 -59.95,-15.19 -22.2,0 -41.84,4.99 -58.9,14.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5178.37,1737.61 c 14.43,0 26.57,4.57 36.43,13.73 9.85,9.16 14.78,20.68 14.78,34.56 0,12.76 -4.51,23.94 -13.53,33.51 -9.02,9.58 -21.02,14.37 -36.01,14.37 h -59.12 v -96.17 z m -103.24,139.05 h 104.49 c 18.04,0 34.35,-3.89 48.92,-11.66 14.57,-7.78 26.08,-18.6 34.56,-32.47 8.45,-13.89 12.69,-29.57 12.69,-47.05 0,-19.98 -6.45,-37.68 -19.35,-53.07 -12.91,-15.41 -29.09,-25.75 -48.51,-31.02 l -0.42,-2.08 82.02,-118.23 v -2.5 h -52.87 l -79.52,116.98 h -36.22 v -116.98 h -45.79 v 298.08",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1760"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.3e9850a98e46514090b4447f404c85b3.svg";
export { ForwardRef as ReactComponent };